import { c as _c } from "react/compiler-runtime";
import { useId } from 'react';
const DOCUMENT_PATH = 'M15 7.5V11.6433C15 11.8617 14.7083 11.9333 14.5833 12.0083C14.2333 11.8 13.8083 11.6667 13.3 11.6667C12.4083 11.675 11.6334 12.025 11.1084 12.6667C10.5084 13.4083 10.2834 14.45 10.4917 15.5333C10.6084 16.1275 10.8542 16.6575 11.1692 17.1175C11.2809 17.28 11.1567 17.5 10.9601 17.5H5C3.33333 17.5 2.5 16.6667 2.5 15V5C2.5 3.33333 3.33333 2.5 5 2.5H10V5C10 6.38083 11.1192 7.5 12.5 7.5H15Z';
const CORNER_PATH = 'M12.5 7.5H15L10 2.5V5C10 6.66667 10.8333 7.5 12.5 7.5Z';
const LINES_PATH = 'M11.6673 10.625H5.83398C5.48898 10.625 5.20898 10.345 5.20898 10C5.20898 9.655 5.48898 9.375 5.83398 9.375H11.6673C12.0123 9.375 12.2923 9.655 12.2923 10C12.2923 10.345 12.0123 10.625 11.6673 10.625ZM9.79232 13.3333C9.79232 12.9883 9.51232 12.7083 9.16732 12.7083H5.83398C5.48898 12.7083 5.20898 12.9883 5.20898 13.3333C5.20898 13.6783 5.48898 13.9583 5.83398 13.9583H9.16732C9.51232 13.9583 9.79232 13.6783 9.79232 13.3333Z';
const HEART_PATH = 'M17.448 15.2963C17.068 17.2238 14.5862 18.3347 14.5862 18.3347C14.5862 18.3347 12.1047 17.2247 11.7247 15.2963C11.4914 14.1138 12.0013 12.9238 13.2972 12.918C14.2622 12.913 14.5862 13.8705 14.5862 13.8705C14.5862 13.8705 14.9105 12.9138 15.8755 12.918C17.1747 12.9238 17.6813 14.1138 17.448 15.2963Z';

//* 시안 아이콘은 DS file-text-heart와 같은 형태의 단색이라, DS 2톤 경로를 그대로 쓰되 글줄·접힌 모서리 틈을 마스크로 뚫는다
export const PolicyPlusIcon = t0 => {
  const $ = _c(13);
  const {
    className
  } = t0;
  const maskId = useId();
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d={DOCUMENT_PATH} fill="white" />;
    t2 = <path d={CORNER_PATH} stroke="black" strokeWidth={1.2} />;
    t3 = <path d={CORNER_PATH} fill="white" />;
    t4 = <path d={LINES_PATH} fill="black" />;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  if ($[4] !== maskId) {
    t5 = <mask id={maskId}>{t1}{t2}{t3}{t4}</mask>;
    $[4] = maskId;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = `url(#${maskId})`;
  let t7;
  if ($[6] !== t6) {
    t7 = <rect width={20} height={20} fill="currentColor" mask={t6} />;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <path d={HEART_PATH} fill="currentColor" />;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== className || $[10] !== t5 || $[11] !== t7) {
    t9 = <svg viewBox="0 0 20 20" fill="none" aria-hidden={true} className={className}>{t5}{t7}{t8}</svg>;
    $[9] = className;
    $[10] = t5;
    $[11] = t7;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  return t9;
};